export { default as MediaCollectionSubChapter } from './MediaCollectionSubChapter';
